var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrucking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3616",
    "data-name": "Group 3616",
    transform: "translate(0.472 0.007)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30.5,
    cy: 29.5,
    rx: 30.5,
    ry: 29.5,
    transform: "translate(-0.472 -0.007)",
    fill: "#e2f4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "truck-moving",
    d: "M15,18H1a1,1,0,0,1-1-1V5.5A4.5,4.5,0,0,1,4.5,1h6A4.5,4.5,0,0,1,15,5.5Zm2-5v5h3a4,4,0,0,0,4-4V13ZM.058,20c-.587,3.954,5.472,3.952,4.884,0Zm6,0c-.587,3.954,5.472,3.952,4.884,0Zm9,0c-.587,3.954,5.472,3.952,4.884,0ZM17,11h6.716c-.024-.08-1.084-3.265-1.084-3.265A3.994,3.994,0,0,0,18.838,5H17Z",
    transform: "translate(17.528 17.993)",
    fill: "#00d1a9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrucking);
export default __webpack_public_path__ + "static/media/trucking.22e41ebe4f6842675168c2801486818a.svg";
export { ForwardRef as ReactComponent };